function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M124.356 52.928a17.005 17.005 0 01-3.336-10.172v-.06C121.02 19.115 98.89 0 71.59 0 54.873 0 40.093 7.17 31.148 18.144c-3.039 3.729-6.708 6.912-10.806 9.482C9.257 34.576 1.927 46.79 2 60.68c.117 21.466 17.789 38.726 39.645 38.726 4.948 0 9.684-.89 14.051-2.517a37.124 37.124 0 0126.974.437c4.209 1.718 8.88 2.674 13.8 2.674C114.987 100 130 86.451 130 69.737c0-6.22-2.079-12.001-5.644-16.81z",
  fill: "#F4F5F6"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.105 66.815C-1.74 78.19 21.388 82.443 21.47 84.645c.083 2.203-11.695 1.32-9.04 7.164 2.462 5.415 20.822 6.666 33.847-.297.377-.202 9.012-17.262 1.595-26.622-7.417-9.359-8.664 7.445-11.905 7.176-3.24-.27 2.788-21.127-3.997-25.18-7.032-4.2-8.403 10.617-11.704 8.521-3.127-1.985-5.75-22.805-13.947-19.676a6.528 6.528 0 00-.913.436l-.003.002a8.217 8.217 0 00-.502.312c-9.325 6.25 10.095 27.34 5.963 28.396-4.131 1.057-9.825-3.826-10.76 1.938z",
  fill: "url(#paint0_linear)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M108.362 19.726l-50.898 7.18 6.028 36.447 50.898-7.18-6.028-36.447z",
  fill: "#fff"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M109.327 52.17l-42.296 5.965-4.64-28.06 42.296-5.965 4.64 28.06z",
  fill: "url(#paint1_linear)"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M109.327 52.17l-42.296 5.965-4.64-28.06 42.296-5.965 4.64 28.06z",
  fill: "url(#paint2_linear)"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M97.793 34.245c1.5 0 2.716-1.124 2.716-2.51 0-1.385-1.216-2.508-2.716-2.508-1.5 0-2.717 1.123-2.717 2.509 0 1.385 1.216 2.509 2.717 2.509z",
  fill: "#fff"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M77.857 39.42l-9.542 18.534 24.637-3.475-15.095-15.058z",
  fill: "url(#paint3_linear)"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M92.498 41.692L85.364 55.55l18.42-2.598-11.286-11.259z",
  fill: "url(#paint4_linear)"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M57.602 3.344C54.209-.234 34.252-.41 30.332 1.776c-5.96 3.32-1.702 17.073 1.039 18.591.765.425 1.822.877 3.045 1.371 1.038 1.922 2.525 3.912 4.634 5.369 0 0-.89-2.232-.557-3.883 4.803 1.58 10.593 2.91 14.54 2.453 6.396-.74 7.962-18.755 4.569-22.333z",
  fill: "url(#paint5_linear)"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M43.766 3.588h-.422a.04.04 0 01-.04-.04V1.893a.04.04 0 01.04-.04h.422a.04.04 0 01.04.04v1.655a.04.04 0 01-.04.04zM40.102 4.44l-.367.208a.04.04 0 01-.054-.014L38.838 3.2a.039.039 0 01.014-.054l.367-.207a.04.04 0 01.054.014l.843 1.434a.039.039 0 01-.014.054zM37.362 6.98l-.211.36a.04.04 0 01-.055.013l-1.46-.827a.039.039 0 01-.014-.054l.211-.36a.04.04 0 01.055-.014l1.46.828c.019.01.025.035.014.054zM36.282 10.524v.415a.04.04 0 01-.04.039h-1.686a.04.04 0 01-.04-.04v-.414a.04.04 0 01.04-.04h1.686a.04.04 0 01.04.04zM37.15 14.123l.212.36a.039.039 0 01-.015.053l-1.46.828a.04.04 0 01-.054-.014l-.211-.36a.039.039 0 01.014-.053l1.46-.828a.04.04 0 01.055.014zM49.748 14.483l.211-.36a.04.04 0 01.055-.014l1.46.828c.019.01.025.035.014.053l-.211.36a.04.04 0 01-.055.014l-1.46-.828a.039.039 0 01-.014-.053zM50.828 10.939v-.415a.04.04 0 01.04-.04h1.686a.04.04 0 01.04.04v.415a.04.04 0 01-.04.039h-1.686a.04.04 0 01-.04-.04zM49.96 7.34l-.212-.36a.039.039 0 01.015-.054l1.46-.828a.04.04 0 01.054.014l.211.36a.039.039 0 01-.014.054l-1.46.827a.04.04 0 01-.055-.014zM47.374 4.648l-.366-.207a.039.039 0 01-.014-.054l.843-1.434a.04.04 0 01.054-.014l.366.207c.02.011.026.035.015.054l-.843 1.434a.04.04 0 01-.055.014z",
  fill: "#fff"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M43.54 5.082c-2.722.008-4.977 2.176-5.04 4.849a4.878 4.878 0 00.766 2.747 9.7 9.7 0 011.496 5.356h5.584v-.194c0-1.822.508-3.613 1.494-5.157.488-.763.77-1.667.77-2.635 0-2.747-2.27-4.974-5.07-4.966z",
  fill: "url(#paint6_linear)"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.763 18.034v1.94a.48.48 0 00.485.476h.457v.316c0 .579.477 1.048 1.067 1.048h1.566c.59 0 1.067-.47 1.067-1.048v-.316h.457a.48.48 0 00.484-.476v-1.94h-5.583z",
  fill: "url(#paint7_linear)"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M44.72 18.084l-.022-.001a.137.137 0 01-.115-.156l1.068-6.557-1.31.817a.14.14 0 01-.19-.038l-.596-.856-.597.856a.14.14 0 01-.189.038l-1.31-.817 1.068 6.557a.137.137 0 01-.115.156.139.139 0 01-.16-.113l-1.117-6.856a.136.136 0 01.061-.136.141.141 0 01.151 0l1.458.908.636-.911c.051-.075.177-.075.229 0l.635.911 1.458-.909a.141.141 0 01.15.002c.047.029.07.082.062.135l-1.117 6.856a.139.139 0 01-.138.114z",
  fill: "url(#paint8_linear)"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M89.33 75.388l-26.88-8.605-6.87 20.7 26.88 8.605 6.87-20.7z",
  fill: "#fff"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M81.127 92.532l-22.337-7.15 5.23-15.758 22.336 7.15-5.23 15.758z",
  fill: "url(#paint9_linear)"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M81.127 92.532l-22.337-7.15 5.23-15.758 22.336 7.15-5.23 15.758z",
  fill: "url(#paint10_linear)"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M80.935 80.543c.824 0 1.492-.656 1.492-1.465s-.668-1.465-1.492-1.465-1.491.656-1.491 1.465c0 .81.667 1.465 1.491 1.465z",
  fill: "#fff"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M69.104 78.25l-9.636 7.35 13.011 4.165-3.375-11.515z",
  fill: "url(#paint11_linear)"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M75.676 82.986l-7.204 5.496 9.728 3.114-2.524-8.61z",
  fill: "url(#paint12_linear)"
});

var _ref21 =
/*#__PURE__*/
React.createElement("path", {
  d: "M116.677 71.393l-19.648.199.151 14.99 19.648-.2-.151-14.99z",
  fill: "#fff"
});

var _ref22 =
/*#__PURE__*/
React.createElement("path", {
  d: "M115.155 84.486l-16.328.161-.118-11.519 16.328-.161.118 11.519z",
  fill: "url(#paint13_linear)"
});

var _ref23 =
/*#__PURE__*/
React.createElement("path", {
  d: "M115.155 84.486l-16.328.161-.118-11.519 16.328-.161.118 11.519z",
  fill: "url(#paint14_linear)"
});

var _ref24 =
/*#__PURE__*/
React.createElement("path", {
  d: "M111.988 76.685c.572 0 1.036-.456 1.036-1.018 0-.563-.464-1.019-1.036-1.019-.573 0-1.037.456-1.037 1.019 0 .562.464 1.018 1.037 1.018z",
  fill: "#fff"
});

var _ref25 =
/*#__PURE__*/
React.createElement("path", {
  d: "M104.008 77.701l-4.685 6.942 9.511-.094-4.826-6.848z",
  fill: "url(#paint15_linear)"
});

var _ref26 =
/*#__PURE__*/
React.createElement("path", {
  d: "M109.407 79.388l-3.502 5.19 7.111-.07-3.609-5.12z",
  fill: "url(#paint16_linear)"
});

var _ref27 =
/*#__PURE__*/
React.createElement("path", {
  d: "M48.74 69.422l-.242-.043-21.139-3.823-3.351-.606-.871 7.04 3.402.2 19.724 1.16 1.082 19.997.044.813 1.561.005.05-.813 1.335-21.93a1.924 1.924 0 00-1.595-2z",
  fill: "#EFBC90"
});

var _ref28 =
/*#__PURE__*/
React.createElement("path", {
  d: "M28.955 63.28c2.108 4.7 19.238 2.963 21.667 7.06 1.96 3.304-.053 20.082-.053 20.082l-4.532-.12s.025-14.285-.862-15.255c-.653-.712-18.84.934-23.377-2.255-3.886-2.73-1.677-9.512-1.677-9.512h8.834z",
  fill: "url(#paint17_linear)"
});

var _ref29 =
/*#__PURE__*/
React.createElement("path", {
  d: "M55.507 94.777l-1.295-.236-4.728-1.837v.038s-.064.797-1.05.94c-.726.105-1.195-.088-1.392-.197-.046-.043-.085-.067-.106-.067-.317-.003-.578.504-.582 1.131-.002.206.025.4.072.566l-.007.872 9.445.069.007-.883a.398.398 0 00-.364-.396z",
  fill: "#03053E"
});

var _ref30 =
/*#__PURE__*/
React.createElement("path", {
  d: "M26.073 92.028l.017-.289 1.282-21.653.211-3.563-7.711.04.249 3.56 1.254 17.9L7.727 81.06l-.784-.4-.856 1.376.72.503 15.897 11.078c.314.218.7.36 1.112.383 1.178.068 2.188-.816 2.257-1.972z",
  fill: "#F4CAAB"
});

var _ref31 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29.624 71.297c-3.526 3.32-.711 21.305-4.146 22.813-3.786 1.662-17.585-9.417-17.585-9.417l1.97-3.87s8.841 5.478 9.57 5.077c.925-.51-3.189-16.113-.38-21.262 2.18-3.999 8.366-3.539 8.366-3.539l2.205 10.198z",
  fill: "url(#paint18_linear)"
});

var _ref32 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1.194 85.663l1.061-.766 4.599-2.13-.028-.026s-.549-.591.02-1.395c.418-.593.883-.796 1.099-.863.063-.004.108-.015.123-.03.218-.225.02-.759-.443-1.192a2.116 2.116 0 00-.47-.335l-.642-.6L0 85.042l.65.609a.408.408 0 00.544.01z",
  fill: "#03053E"
});

var _ref33 =
/*#__PURE__*/
React.createElement("path", {
  d: "M40.071 50.892l-3.38-2.005 3.905-6.35 2.066 1.224-2.591 7.13z",
  fill: "#EFBC90"
});

var _ref34 =
/*#__PURE__*/
React.createElement("path", {
  d: "M48.45 42.807c-1.033 2.946-3.071 5.324-5.024 4.943-1.832-.356-3.57-3.318-3.179-6.603.412-3.458 2.273-5.122 4.962-4.557 2.858.6 4.371 2.988 3.24 6.217z",
  fill: "#F4CAAB"
});

var _ref35 =
/*#__PURE__*/
React.createElement("path", {
  d: "M43.544 41.33c.903-.93 2.152-.89 3.065-.744.912.148 2.234.932 2.59.355.355-.578.659-2.999-2.784-4.606-3.116-1.455-5.681-.219-7.16 1.859-1.293 1.818-.754 4.468.97 4.609 1.724.141 2.227-.35 3.32-1.474z",
  fill: "#03053E"
});

var _ref36 =
/*#__PURE__*/
React.createElement("path", {
  d: "M42.108 43.139c.47.06.911-.34.986-.893.074-.554-.247-1.053-.717-1.113-.47-.061-.91.338-.985.892-.075.555.246 1.053.716 1.114z",
  fill: "#F4CAAB"
});

var _ref37 =
/*#__PURE__*/
React.createElement("path", {
  d: "M47.15 33.233c.148 1.521-1.233 3.482-3.156 3.663-1.922.182-3.658-1.484-3.807-3.005-.15-1.522 1.374-2.032 3.296-2.214 1.923-.181 3.517.035 3.666 1.556z",
  fill: "#03053E"
});

var _ref38 =
/*#__PURE__*/
React.createElement("path", {
  d: "M36.948 51.19l7.33 7.762-2.006.289L48.2 48.904l.462-.806 1.62.842-.418.829-5.371 10.627a1.243 1.243 0 01-1.952.341l-.055-.052-7.791-7.318-1.143-1.073 2.32-2.243 1.075 1.138z",
  fill: "#EFBC90"
});

var _ref39 =
/*#__PURE__*/
React.createElement("path", {
  d: "M51.11 45.553c.55.336.709 1.555.126 2.783-.537 1.133-1.575 1.507-2.15 1.2-1.282-.686 1.175-4.504 2.025-3.983z",
  fill: "#EFBC90"
});

var _ref40 =
/*#__PURE__*/
React.createElement("path", {
  d: "M49.5 45.72c-.28-.048-.754.56-1.01 1.49-.238.858-.061 1.508.216 1.583.62.166 1.229-3 .795-3.074z",
  fill: "#EFBC90"
});

var _ref41 =
/*#__PURE__*/
React.createElement("path", {
  d: "M34.157 50.554c2.155-1.59 4.443 1.27 5.33 2.232.886.963 2.82 3.938 3.528 3.792.71-.145 3.924-6.698 4.43-6.616.505.08 1.954.926 2.12 1.308.166.381-2.774 9.972-5.829 10.436-1.448.22-6.104-3.556-7.051-4.32-.947-.764-5.747-4.458-2.528-6.832z",
  fill: "url(#paint19_linear)"
});

var _ref42 =
/*#__PURE__*/
React.createElement("path", {
  d: "M37.856 47.592s-11.159 4.587-15.941 14.113c0 0-1.645 1.412 4.874 5.314 6.52 3.903 7.465 3.278 7.465 3.278 1.165-6.024 3.2-12.376 6.754-19.305 0 0-2.436-1.461-3.152-3.4z",
  fill: "url(#paint20_linear)"
});

var _ref43 =
/*#__PURE__*/
React.createElement("path", {
  d: "M41.27 50.108s-5.397 7.541-7.977 13.698c-2.58 6.156-2.707 12.38-2.707 12.38S17.46 68.435 17.23 64.546C17 60.658 33.247 47.915 37.73 47.136l3.54 2.972z",
  fill: "url(#paint21_linear)"
});

var _ref44 =
/*#__PURE__*/
React.createElement("path", {
  d: "M53.334 39.026l-2.27-.606a.195.195 0 00-.24.134l-.934 3.38c-.02.07.005.138.053.185l-.567 2.05a.196.196 0 00.14.242l.584.156a.2.2 0 00.245-.138l.56-2.026.997.266a.195.195 0 00.232-.113l1.33-3.275a.19.19 0 00-.13-.255z",
  fill: "url(#paint22_linear)"
});

var _ref45 =
/*#__PURE__*/
React.createElement("path", {
  d: "M50.903 42.662l-1.081-.289a.2.2 0 00-.246.138l-.854 3.087a.196.196 0 00.14.242l1.082.288a.2.2 0 00.245-.138l.855-3.087a.196.196 0 00-.14-.241zM58.983 46.414l-7.94-2.119a.087.087 0 00-.106.06l-1.126 4.068a.085.085 0 00.061.105l7.94 2.119a.087.087 0 00.107-.06l1.125-4.068a.085.085 0 00-.061-.105z",
  fill: "#03053E"
});

var _ref46 =
/*#__PURE__*/
React.createElement("path", {
  d: "M50.093 43.72l-1.542-.411-1.31 4.736 1.541.412 1.311-4.737z",
  fill: "#03053E"
});

var _ref47 =
/*#__PURE__*/
React.createElement("path", {
  d: "M58.914 46.202l-6.662-1.778a.087.087 0 00-.107.06l-1.226 4.428a.085.085 0 00.062.105l6.662 1.778a.087.087 0 00.107-.06l1.225-4.428a.086.086 0 00-.061-.105z",
  fill: "url(#paint23_linear)"
});

var _ref48 =
/*#__PURE__*/
React.createElement("path", {
  d: "M58.404 45.794l-5.502-1.469a.087.087 0 00-.107.06l-1.366 4.935a.086.086 0 00.062.105l5.502 1.469a.087.087 0 00.106-.06l1.366-4.935a.086.086 0 00-.062-.105z",
  fill: "url(#paint24_linear)"
});

var _ref49 =
/*#__PURE__*/
React.createElement("path", {
  d: "M51.243 43.072l-1.836-.49a.54.54 0 00-.66.371l-1.547 5.59a.527.527 0 00.378.648l1.837.49a.539.539 0 00.66-.371l1.546-5.59a.527.527 0 00-.378-.648z",
  fill: "url(#paint25_linear)"
});

var _ref50 =
/*#__PURE__*/
React.createElement("path", {
  d: "M36.997 51.877l7.3 7.792-2.008.281 5.97-10.314.466-.804 1.617.849-.422.827-5.414 10.606a1.243 1.243 0 01-1.953.333l-.055-.052-7.761-7.348-1.139-1.078 2.329-2.234 1.07 1.142z",
  fill: "#F4CAAB"
});

var _ref51 =
/*#__PURE__*/
React.createElement("path", {
  d: "M51.183 46.297c.548.339.702 1.558.114 2.785-.541 1.13-1.58 1.5-2.154 1.19-1.28-.69 1.193-4.498 2.04-3.975z",
  fill: "#F4CAAB"
});

var _ref52 =
/*#__PURE__*/
React.createElement("path", {
  d: "M34.21 51.232c2.161-1.582 4.437 1.287 5.32 2.254.882.966 2.803 3.948 3.513 3.806.71-.143 3.95-6.683 4.456-6.6.505.083 1.95.935 2.115 1.317.165.382-2.814 9.961-5.87 10.413-1.45.215-6.09-3.58-7.034-4.347-.944-.768-5.729-4.48-2.5-6.843z",
  fill: "url(#paint26_linear)"
});

var _ref53 =
/*#__PURE__*/
React.createElement("path", {
  d: "M49.572 46.457c-.28-.049-.756.558-1.017 1.487-.24.856-.067 1.507.21 1.583.62.168 1.241-2.995.807-3.07z",
  fill: "#F4CAAB"
});

var _ref54 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 16.142,
  y1: 60.938,
  x2: 54.266,
  y2: 92.783,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#EAEAEA"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#C6C6C6"
})), React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 64.71,
  y1: 44.106,
  x2: 130.802,
  y2: 33.175,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FFE2E4"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#A4B8EA"
})), React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 77.028,
  y1: 58.957,
  x2: 92.084,
  y2: 5.893,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#80CCFF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F2FAFF"
})), React.createElement("linearGradient", {
  id: "paint3_linear",
  x1: 64.221,
  y1: 48.798,
  x2: 84.213,
  y2: 59.013,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#2C41BB"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#798FF4"
})), React.createElement("linearGradient", {
  id: "paint4_linear",
  x1: 82.303,
  y1: 48.703,
  x2: 97.25,
  y2: 56.341,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#2C41BB"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#798FF4"
})), React.createElement("linearGradient", {
  id: "paint5_linear",
  x1: 63.5,
  y1: 19,
  x2: 57.511,
  y2: -3.223,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FF8200"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#FFC1A6"
})), React.createElement("linearGradient", {
  id: "paint6_linear",
  x1: 41.708,
  y1: 10.511,
  x2: 49.701,
  y2: 16.752,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#fff"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#E9E9E9"
})), React.createElement("linearGradient", {
  id: "paint7_linear",
  x1: 46.346,
  y1: 21.814,
  x2: 42.287,
  y2: 20.314,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#D3D3D3"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#C5C5C5"
})), React.createElement("linearGradient", {
  id: "paint8_linear",
  x1: 45.977,
  y1: 18.085,
  x2: 42.086,
  y2: 17.427,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#D3D3D3"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#C5C5C5"
})), React.createElement("linearGradient", {
  id: "paint9_linear",
  x1: 61.404,
  y1: 77.503,
  x2: 96.321,
  y2: 89.09,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FFE2E4"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#A4B8EA"
})), React.createElement("linearGradient", {
  id: "paint10_linear",
  x1: 67.386,
  y1: 93.086,
  x2: 78.741,
  y2: 58.175,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#80CCFF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F2FAFF"
})), React.createElement("linearGradient", {
  id: "paint11_linear",
  x1: 57.306,
  y1: 84.076,
  x2: 68.508,
  y2: 88.941,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#37A6EE"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#8AC5E7"
})), React.createElement("linearGradient", {
  id: "paint12_linear",
  x1: 66.855,
  y1: 87.342,
  x2: 75.23,
  y2: 90.98,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#37A6EE"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#8AC5E7"
})), React.createElement("linearGradient", {
  id: "paint13_linear",
  x1: 98.78,
  y1: 78.886,
  x2: 124.394,
  y2: 78.622,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FFE2E4"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#A4B8EA"
})), React.createElement("linearGradient", {
  id: "paint14_linear",
  x1: 103.838,
  y1: 84.93,
  x2: 108.917,
  y2: 66.658,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#80CCFF"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#F2FAFF"
})), React.createElement("linearGradient", {
  id: "paint15_linear",
  x1: 97.743,
  y1: 81.214,
  x2: 105.362,
  y2: 85.226,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#37A6EE"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#8AC5E7"
})), React.createElement("linearGradient", {
  id: "paint16_linear",
  x1: 104.723,
  y1: 82.014,
  x2: 110.42,
  y2: 85.014,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#37A6EE"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#8AC5E7"
})), React.createElement("linearGradient", {
  id: "paint17_linear",
  x1: 49.483,
  y1: 71.009,
  x2: 35.647,
  y2: 76.936,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#435AC2"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#0F24A4"
})), React.createElement("linearGradient", {
  id: "paint18_linear",
  x1: 25.024,
  y1: 77.668,
  x2: 13.424,
  y2: 80.949,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#435AC2"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#0F24A4"
})), React.createElement("linearGradient", {
  id: "paint19_linear",
  x1: 37.092,
  y1: 35.872,
  x2: 30.923,
  y2: 53.66,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FF8200"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#FF4D00"
})), React.createElement("linearGradient", {
  id: "paint20_linear",
  x1: 40.664,
  y1: 48.532,
  x2: 28.427,
  y2: 51.538,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FF8200"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#FF4D00"
})), React.createElement("linearGradient", {
  id: "paint21_linear",
  x1: 40.84,
  y1: 48.336,
  x2: 24.678,
  y2: 43.121,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FF8200"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#FF4D00"
})), React.createElement("linearGradient", {
  id: "paint22_linear",
  x1: 49.369,
  y1: 41.493,
  x2: 53.478,
  y2: 41.493,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#435AC2"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#0F24A4"
})), React.createElement("linearGradient", {
  id: "paint23_linear",
  x1: 50.916,
  y1: 47.61,
  x2: 58.978,
  y2: 47.61,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#435AC2"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#0F24A4"
})), React.createElement("linearGradient", {
  id: "paint24_linear",
  x1: 58.468,
  y1: 47.609,
  x2: 51.426,
  y2: 47.609,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#435AC2"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#0F24A4"
})), React.createElement("linearGradient", {
  id: "paint25_linear",
  x1: 47.181,
  y1: 46.132,
  x2: 51.64,
  y2: 46.132,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#435AC2"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#0F24A4"
})), React.createElement("linearGradient", {
  id: "paint26_linear",
  x1: 49.326,
  y1: 51.176,
  x2: 39.903,
  y2: 46.008,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#FF8200"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#FF4D00"
})));

var SvgNormalPhotoIcon = function SvgNormalPhotoIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 130,
    height: 100,
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNormalPhotoIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/normal-photo-icon.75ebdd10.svg";
export { ForwardRef as ReactComponent };